import React from 'react';
import { Link } from 'react-router-dom';

import branding from '../../config/branding';

import {
  BottomBar,
  Brand,
  BrandColumn,
  BrandDescription,
  Column,
  Container,
  Content,
  LegalLinks,
} from './styles';

import logoIcon from '../../assets/logo.svg';

const Footer: React.FC = () => {
  return (
    <Container>
      <Content>
        <BrandColumn>
          <Brand>
            <img src={logoIcon} alt="logo" />
            <span>TRENZOX</span>
          </Brand>
          <BrandDescription>
            Gestão inteligente de treinos, alunos e financeiro para academias e
            estúdios.
          </BrandDescription>
        </BrandColumn>

        <Column>
          <h4>Produto</h4>
          <Link to="/#recursos">Recursos</Link>
          <Link to="/#precos">Planos e preços</Link>
          <Link to="/#faq">FAQ</Link>
        </Column>

        <Column>
          <h4>Aplicativos</h4>
          <Link to="/#cta">App do aluno</Link>
          <Link to="/#cta">App da equipe</Link>
          <Link to="/#cta">Painel web</Link>
        </Column>

        <Column>
          <h4>Contato</h4>
          <a href={`mailto:${branding.supportEmail}`}>Fale com a equipe</a>
          <Link to="/support">Central de suporte</Link>
        </Column>
      </Content>

      <BottomBar>
        <span>© 2026 TrenzoX. Todos os direitos reservados.</span>
        <LegalLinks>
          <Link to="/terms">Termos de uso</Link>
          <Link to="/privacy">Privacidade</Link>
          <Link to="/delete-account">Excluir conta</Link>
        </LegalLinks>
      </BottomBar>
    </Container>
  );
};

export { Footer };
